import I18nLang from './src/main';

/* istanbul ignore next */
I18nLang.install = function(Vue) {
  Vue.component(I18nLang.name, I18nLang);
};

export default I18nLang;
